/** Soccer and other sports may include a Draw/Tie outcome in the h2h (moneyline) market. */

const DRAW_OUTCOME_NAMES = new Set(["draw", "tie"]);

export function normalizeOutcomeName(name) {
  return String(name ?? "")
    .trim()
    .toLowerCase();
}

export function isDrawOutcomeName(name) {
  return DRAW_OUTCOME_NAMES.has(normalizeOutcomeName(name));
}

export function getDrawDisplayLabel(name = "Draw") {
  const raw = String(name ?? "").trim();
  if (!raw) return "Draw";
  return raw.toLowerCase() === "tie" ? "Tie" : "Draw";
}

export function findOutcomeByTeamName(market, teamName) {
  const outcomes = market?.outcomes;
  if (!Array.isArray(outcomes) || !teamName) {
    return { outcome: null, index: -1 };
  }
  const index = outcomes.findIndex((o) => o?.name === teamName);
  return {
    outcome: index >= 0 ? outcomes[index] : null,
    index,
  };
}

export function findDrawOutcome(market) {
  const outcomes = market?.outcomes;
  if (!Array.isArray(outcomes)) {
    return { outcome: null, index: -1 };
  }
  const index = outcomes.findIndex((o) => isDrawOutcomeName(o?.name));
  return {
    outcome: index >= 0 ? outcomes[index] : null,
    index,
  };
}

export function hasThreeWayH2h(market) {
  return findDrawOutcome(market).index >= 0;
}

export function resolveH2hSides(market, homeTeam, awayTeam) {
  const home = findOutcomeByTeamName(market, homeTeam);
  const away = findOutcomeByTeamName(market, awayTeam);
  const draw = findDrawOutcome(market);

  return {
    home,
    away,
    draw,
    isThreeWay: draw.index >= 0,
  };
}
